import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-white text-lg font-medium" }, "Notifications", -1)
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col gap-4 mt-6"
}
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col gap-4 mt-6"
}
const _hoisted_5 = { class: "text-gray-900 text-sm font-medium" }
const _hoisted_6 = { class: "text-gray-500 text-xs" }
const _hoisted_7 = {
  key: 2,
  class: "text-center"
}

import { computed } from "vue"
import JobItem from "@/components/jobs/JobItem.vue"
import { XIcon } from "@heroicons/vue/outline"
import { useSocketStore } from "@/stores/socket"

interface Props {
    modelValue: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsSidebar',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const socketStore = useSocketStore()

const props = __props
const emit = __emit

const isNotificationSidebarVisible = computed({
    get: () => props.modelValue,
    set: (value: boolean) => {
        emit("update:modelValue", value)
    },
})

const jobsArray = computed(() => Object.entries(socketStore.inProgressJobs))
const taskReminders = computed(() => Object.entries(socketStore.taskReminders))

function closeDialog() {
    isNotificationSidebarVisible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createBlock(_component_Sidebar, {
    visible: isNotificationSidebarVisible.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((isNotificationSidebarVisible).value = $event)),
    position: "right",
    autoZIndex: "",
    showCloseIcon: false
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(XIcon), {
          class: "h-6 w-6 text-white cursor-pointer",
          onClick: closeDialog
        })
      ])
    ]),
    default: _withCtx(() => [
      (jobsArray.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobsArray.value, ([key, job]) => {
              return (_openBlock(), _createBlock(JobItem, {
                key: key,
                jobTitle: job.title,
                jobDescription: job.description,
                jobProgress: job.progress ? job.progress : 0
              }, null, 8, ["jobTitle", "jobDescription", "jobProgress"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (taskReminders.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taskReminders.value, ([key, task]) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex flex-col px-5 py-4 gap-3 rounded-xl bg-gray-100",
                key: key
              }, [
                _createElementVNode("span", _hoisted_5, [
                  _createTextVNode("Reminder: "),
                  _createElementVNode("b", null, _toDisplayString(task.title), 1)
                ]),
                _createElementVNode("p", _hoisted_6, _toDisplayString(task.description), 1)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, "You have no notifications yet."))
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})